import axios from 'axios'
import { useMutation } from 'react-query'

import type { MutationConfig } from '@/lib/react-query'
import type { ContactReqbody } from '@/server/contact/CreateContactMessage/type'

type SendContactProps = {
  token: string
} & ContactReqbody

export const sendContact = async (data: SendContactProps) => {
  return await axios.post(`/api/contact`, data)
}

type Props = MutationConfig<typeof sendContact>
export const UseSendContactMutation = (props: Props) => {
  return useMutation({
    ...props,
    mutationFn: sendContact,
  })
}
